// extracted by mini-css-extract-plugin
module.exports = {"button":"FavoritesNotification_button__j8Edo","root":"FavoritesNotification_root__CNCzW"};